<template>
    <AlbertaHeader />
    <div class="page-main">
        <Header class="header" />
        <div class="split-col">
            <div class="left">
                <div class="map-wrapper">
                    <MapLegend class="legend" />
                    <Map class="map" />
                </div>
            </div>
            <div class="right">
                <Search class="search" />
                <List class="list" />
            </div>
        </div>
    </div>
    <AlbertaFooter />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import AlbertaHeader from '../components/AlbertaAssets/AlbertaHeader.vue';
import AlbertaFooter from '../components/AlbertaAssets/AlbertaFooter.vue';
import Header from '../components/Header/Header.vue';
import MapLegend from '../components/MapLegend/MapLegend.vue';
import Map from '../components/Map/Map.vue';
import Search from '../components/Search/Search.vue';
import List from '../components/List/List.vue';

export default defineComponent({
    name: 'MainPage',
    components: {
        AlbertaHeader,
        AlbertaFooter,
        Header,
        MapLegend,
        Map,
        Search,
        List
    },
    setup() {}
});
</script>

<style lang="postcss" scoped>
.page-main {
    @apply w-full max-w-app mx-auto mt-0 mb-8 flex flex-col p-4;

    .header {
        @apply mb-5;
    }

    .split-col {
        @apply grid grid-cols-2 w-full col-gap-5;
        grid-template-columns: 40% 1fr;
        height: 750px;
    }

    .right {
        @apply flex flex-col items-stretch border-l-2 border-blue-300 h-full overflow-auto;
    }

    .map-wrapper {
        @apply w-full;

        .legend {
            @apply mb-4;
        }

        .map {
            height: 600px;
        }
    }

    .search {
        @apply ml-4 mb-4;
    }
}
</style>
